/** Mist context banner with a 40px badge (prototype `.ctx`), shown above the grid. */
import { FC } from "react"
import { TextStyle, View, ViewStyle } from "react-native"
import Icon from "react-native-vector-icons/MaterialIcons"

import { Text } from "@/components/Text"

import type { ContextBannerData } from "./rescheduleSlotModel"
import { font, tokens } from "./tokens"

export const ContextBanner: FC<ContextBannerData> = ({ title, body, tone }) => {
  const neutral = tone === "neutral"
  return (
    <View style={$banner} testID="context-banner">
      <View style={[$badge, neutral && $badgeNeutral]} testID="context-badge">
        <Icon
          name={neutral ? "schedule" : "error-outline"}
          size={20}
          color={neutral ? tokens.ink : tokens.red}
        />
      </View>
      <View style={$texts}>
        <Text style={$title}>{title}</Text>
        <Text style={$body}>{body}</Text>
      </View>
    </View>
  )
}

const $banner: ViewStyle = {
  flexDirection: "row",
  alignItems: "center",
  gap: 12,
  padding: 12,
  borderRadius: 12,
  backgroundColor: tokens.mist,
}
const $badge: ViewStyle = {
  width: 40,
  height: 40,
  borderRadius: 10,
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  backgroundColor: tokens.redTint,
}
const $badgeNeutral: ViewStyle = { backgroundColor: tokens.surface }
const $texts: ViewStyle = { flex: 1, minWidth: 0 }
const $title: TextStyle = { fontSize: 14, lineHeight: 18, fontFamily: font.bold, color: tokens.ink }
const $body: TextStyle = {
  fontSize: 13,
  lineHeight: 18,
  marginTop: 2,
  fontFamily: font.regular,
  color: tokens.ink70,
}
